import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

type PortalProps = {
  className?: string;
  isOpen: boolean;
  children: React.ReactNode;
};

const Portal: React.FC<PortalProps> = (props: PortalProps) => {
  const { children, isOpen, className } = props;
  const portalRef = useRef<HTMLDivElement | null>(
    document.createElement('div'),
  );

  const portal = portalRef?.current;

  const portalClassName = classNames('res-portal', className);

  useEffect(() => {
    if (!portal) return;

    if (isOpen) {
      const { body } = document;

      body?.appendChild(portal);
      portal.classList.add(...portalClassName.split(' '));

      return () => {
        body?.removeChild(portal);
      };
    }
  }, [isOpen, portal, portalClassName]);

  if (!portal) return null;
  return ReactDOM.createPortal(children, portal);
};

export default Portal;
